import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

const NetworkStatusBar: React.FC = () => {
  const { t } = useTranslation('common');
  const isOnline = useNetworkStatus();
  const [showReconnected, setShowReconnected] = useState(false);
  const wasOffline = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOffline.current = true;
      setShowReconnected(false);
    } else if (wasOffline.current) {
      wasOffline.current = false;
      setShowReconnected(true);
      const timer = setTimeout(() => setShowReconnected(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  if (isOnline && !showReconnected) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        padding: '8px 16px',
        textAlign: 'center',
        fontWeight: 500,
        fontSize: '14px',
        color: '#fff',
        backgroundColor: isOnline ? '#16a34a' : '#dc2626',
        transition: 'background-color 0.3s ease',
      }}
    >
      {isOnline ? t('network.backOnline') : t('network.offline')}
    </div>
  );
};

export default NetworkStatusBar;
